import './lpiSchedule.css';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, NavItem, Table } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/Search";
import DatePicker from "react-datepicker";
import { authKey, GET_SCHEDULE_NO_LIST, GET_WEEKLY_SCHEDULE_PLAN_BY_SCHEDULE_NO, GET_STAKEHOLDER_CATEGORY, APPROVE_STAKEHOLDER_SCHEDULE } from '../../../common/URLs';

import jwt from 'jwt-decode';
import { DataGrid } from '@mui/x-data-grid';
import { Button, Box, TextField, Card, Grid, FormControl, InputLabel, IconButton, MenuItem, Select, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab, CardContent } from '@mui/material'
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import moment from 'moment';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { PROD } from '../../../common/constants';
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import { ConfirmPopover } from "../../../preregcamps/confirmPopover/confirmPopover";
import { toast } from 'react-toastify';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
// import { addWeeks, format } from 'date-fns';
import { Clear as CancelIcon, Done as ApproveIcon } from '@mui/icons-material';
import addDays from 'date-fns/addDays';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { useTranslation } from "react-i18next";
import apiClient from '../../../axios';

function LpiSchedule() {
  // const [selectedDate, handleDateChange] = useState(new Date());
  // const oneWeekLater = addWeeks(selectedDate, 1);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const decoded = jwt(getLocalStorageItem('id_token'));
  const [lpischeduleno, setLpischeduleno] = useState([]);
  const [lpiweeklyscheduledata, setLpiweeklyscheduledata] = useState();
  const [lpiVisible, setLpiVisible] = useState();
  const [stakeholderDetails, setStakeholderDetails] = useState();
  const [tabValue, setTabValue] = React.useState("Chipping");
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(addDays(new Date(), 7));
  const [unloadingFromDate, setUnloadingFromDate] = useState(new Date());
  const [unloadingToDate, setUnloadingToDate] = useState(addDays(new Date(), 7));
  const [laterDate, setLaterDate] = useState();
  const [searchVisible, setSearchvisible] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [approveButtonData, setApproveButtonData] = useState();
  const [approveDataList, setApproveDataList] = useState();

  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const [logModalOpen2, setLogModalOpen2] = useState(false);
  const handleLogModalOpen2 = () => setLogModalOpen2(true);
  const handleLogModalClose2 = () => setLogModalOpen2(false);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const handleConfirmOpen = () => setConfirmOpen(true);
  const handleConfirmClose = () => setConfirmOpen(false);

  const [confirmOpen2, setConfirmOpen2] = useState(false);
  const handleConfirmOpen2 = () => setConfirmOpen2(true);
  const handleConfirmClose2 = () => setConfirmOpen2(false);

  const [searchFilter, setSearchFilter] = useState({
    "weeklyScheduleNumber": "",
    "pickUpFromDate": fromDate,
    "pickUpToDate": toDate
  });

  const lpiharvestingDetails = (cellValues) => {
    navigate('./harvestingDetails', {
      state: { selectedRow: cellValues.row }
    });
  }
  useEffect(() => {
    // if (decoded.extension_URN) {
    getStakeDetails();
    // }
  }, [decoded.extension_URN]);

  function getStakeDetails() {
    apiClient
      .post(GET_STAKEHOLDER_CATEGORY,
        {
          "urn": decoded.extension_URN,
          "type": ""
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setStakeholderDetails(response.data);
      })
      .catch(function (error) {
        console.log(error);
        toast.error(error.message);
      });
  }

  useEffect(() => {
    getLpiScheduleNo();
  }, []);

  const getLpiScheduleNo = () => {
    apiClient
      .post(GET_SCHEDULE_NO_LIST,
        {
          "stakeholderUrn": decoded.extension_URN
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setLpischeduleno(response.data.scheduleNoList);
        getLpiWeeklySchedule({ target: { value: response.data.scheduleNoList[0] } }, '');

      })
      .catch(function (error) {
        console.log(error);
        toast.error(error.message);
      });
  }
  useEffect(() => {
    if (stakeholderDetails) {
      getLpiScheduleNo();
    }
  }, [stakeholderDetails]);

  const getLpiWeeklySchedule = (e, serachvalue, tabUpdate) => {
    if (stakeholderDetails?.category) {
      let weeklyNo = e?.target?.value
      let tabVal = tabUpdate ? tabUpdate : tabValue
      // if (weeklyNo) { setSearchFilter('') }
      if (weeklyNo) { setSearchFilter({ "weeklyScheduleNumber": weeklyNo }) }
      loaderService.showLoader()
      apiClient
        .post(GET_WEEKLY_SCHEDULE_PLAN_BY_SCHEDULE_NO,
          {
            "weeklyScheduleNumber": weeklyNo ? weeklyNo : serachvalue,
            "stakeholderUrn": decoded.extension_URN,
            "stakeholderType": stakeholderDetails?.category,
            "activityType": tabVal,
            "pickUpFromDate": tabVal === "Loading" || tabVal === "Unloading" ? fromDate : null,
            "pickUpToDate": tabVal === "Loading" || tabVal === "Unloading" ? toDate : null,
          },
          {
            headers: {
              Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
            }
          }, null
        )
        .then((response) => {
          setLpiweeklyscheduledata(response.data.weeklySchedulePlanDetailsList);
          loaderService.hideLoader();
        })
        .catch(function (error) {
          console.log(error);
          loaderService.hideLoader();
          toast.error(error.message);
        });
    }
  }
  const handleFilter = (e) => {
    if (e.target.name === "weeklyScheduleNumber") {
      setSearchFilter({ ...searchFilter, [e.target.name]: e.target.value })
    }
  }
  function searchScheduleDetails(e) {
    e.preventDefault();
    getLpiWeeklySchedule(e, searchFilter?.weeklyScheduleNumber);
  }

  // const onload = (e, loadingType) => {
  //   e.preventDefault();
  //   const userData = {
  //     urn: decoded.extension_URN,
  //     activityTypeLoad: loadingType
  //   };
  //   navigate("/ghtSchedule", { state: { data: userData } });
  // }

  const columns = [
    { field: 'weeklyScheduleNumber', headerName: 'Schedule No', width: 280 },
    { field: 'scheduleLineNumber', headerName: 'Schedule Line No', width: 160 },
    {
      field: 'schedulePickupDate', headerName: t('reg.date'), width: 140,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
    },
    { field: 'scheduleRbCbQuantity', headerName: 'Quantity for Chipping', width: 180 },
    {
      field: 'isScheduledApproved', headerName: 'Approval Status', width: 150,
      valueFormatter: (params) => {
        if (params.value === true) {
          return 'Approved';
        }
        else if (params.value === false) {
          return 'Rejected';
        }
        else {
          return 'Not Approved';
        }
      },
      getCellValue: (params) => {
        if (params?.row?.scheduleStakeholderType === stakeholderDetails?.category) {
          return <>{params?.row?.isScheduledApproved}</>;
        } else if (params?.row?.firstPartyType === stakeholderDetails?.category) {
          return <>{params?.row?.isFirstPartyApproved}</>;
        } else {
          return <>{params?.row?.isSecondPartyApproved}</>;
        }
      },
    },
  ];

  const columns2 = [
    { field: 'weeklyScheduleNumber', headerName: 'Schedule No', width: 250 },
    { field: 'scheduleLineNumber', headerName: 'Schedule Line No', width: 150 },
    {
      field: 'schedulePickupDate', headerName: 'Pick up Date', width: 150,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
    },
    { field: 'scheduleRbCbQuantity', headerName: 'Quantity', width: 150 },
    {
      field: 'stakeholderUrn', headerName: 'URN(1stParty)', width: 150, hide: (tabValue === "Unloading" && stakeholderDetails?.category === "LLE"),
      renderCell: (cellValues) => {
        return (
          tabValue === "Loading" ?
            <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderUrn : cellValues?.row?.firstPartyUrn}</>
            :
            <> {cellValues?.row?.firstPartyUrn} </>
        );
      }
    },
    {
      field: 'stakeholderContactNo', headerName: 'Contact Details(1stParty)', width: 150, hide: (tabValue === "Unloading" && stakeholderDetails?.category === "LLE"),
      renderCell: (cellValues) => {
        return (
          tabValue === "Loading" ?
            <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderContactNo : cellValues?.row?.firstPartyContactNo}</>
            :
            <> {cellValues?.row?.firstPartyContactNo} </>
        );
      }
    },
    {
      field: 'stakeholderLocationName', headerName: 'Location(1stParty)', width: 150, hide: (tabValue === "Unloading" && stakeholderDetails?.category === "LLE"), renderCell: (cellValues) => {
        return (
          tabValue === "Loading" ?
            <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderLocationName : cellValues?.row?.firstPartyLocationName}</>
            :
            <> {cellValues?.row?.firstPartyLocationName} </>
        );
      }
    },
    {
      field: 'secondPartyUrn', headerName: 'URN(2ndParty)', width: 150,
      renderCell: (cellValues) => {
        return (
          tabValue === "Unloading" ?
            <>{cellValues?.row?.secondPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderUrn : cellValues?.row?.secondPartyUrn}</>
            :
            <> {cellValues?.row?.secondPartyUrn} </>
        );
      }
    },
    {
      field: 'secondPartyContactNo', headerName: 'Contact Details(2ndParty)', width: 150,
      renderCell: (cellValues) => {
        return (
          tabValue === "Unloading" ?
            <>{cellValues?.row?.secondPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderContactNo : cellValues?.row?.secondPartyContactNo}</>
            :
            <> {cellValues?.row?.secondPartyContactNo} </>
        );
      }
    },
    {
      field: 'secondPartyLocationName', headerName: 'Location(2ndParty)', width: 150,
      renderCell: (cellValues) => {
        return (
          tabValue === "Unloading" ?
            <>{cellValues?.row?.secondPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderLocationName : cellValues?.row?.secondPartyLocationName}</>
            :
            <> {cellValues?.row?.secondPartyLocationName} </>
        );
      }
    },
    {
      field: 'scheduledDeliveryDate', headerName: 'Delivery Date', width: 150,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY")
    },
    { field: 'poStpoNumber', headerName: 'PO Number', width: 150 },
    { field: 'inventoryType', headerName: 'Type of Inventory', width: 150 },
    {
      field: 'isScheduledApproved', headerName: 'Approval Status', width: 150,
      valueFormatter: (params) => {
        if (params.value === true) {
          return 'Approved';
        }
        else if (params.value === false) {
          return 'Rejected';
        }
        else {
          return 'Not Approved';
        }
      },
      getCellValue: (params) => {
        if (params?.row?.scheduleStakeholderType === stakeholderDetails?.category) {
          return <>{params?.row?.isScheduledApproved}</>;
        } else if (params?.row?.firstPartyType === stakeholderDetails?.category) {
          return <>{params?.row?.isFirstPartyApproved}</>;
        } else {
          return <>{params?.row?.isSecondPartyApproved}</>;
        }
      },
    },
    // { field: '', headerName: 'Action', width: 100 },
    // {
    //   field: 'Navigate', headerName: 'Navigate', width: 200, hide: stakeholderDetails?.category != "HIT",
    //   renderCell: (cellValues) => {
    //     return (
    //       <Button
    //         variant="contained"
    //         color="primary"
    //         onClick={() => harvestingDetails(cellValues)}
    //       >
    //         Harvesting Details
    //       </Button>
    //     );
    //   }
    // },
    // {
    //   field: 'Print', headerName: "Print", width: 200, hide: stakeholderDetails?.category != "HIT",
    //   renderCell: () => {
    //     return (
    //       <Button
    //         variant="contained"
    //         color="primary"
    //       >
    //         Print
    //       </Button>
    //     );
    //   }
    // }
  ];

  const columns3 = [
    { field: 'weeklyScheduleNumber', headerName: 'Schedule No', width: 250 },
    { field: 'scheduleLineNumber', headerName: 'Schedule Line No', width: 150 },
    {
      field: 'schedulePickupDate', headerName: 'Pick up Date', width: 150,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
    },
    { field: 'scheduleRbCbQuantity', headerName: 'Quantity', width: 150 },
    {
      field: 'stakeholderUrn', headerName: 'URN(1stParty)', width: 150, hide: (tabValue === "Unloading" && stakeholderDetails?.category === "LLE"),
      renderCell: (cellValues) => {
        return (
          tabValue === "Loading" ?
            <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderUrn : cellValues?.row?.firstPartyUrn}</>
            :
            <> {cellValues?.row?.firstPartyUrn} </>
        );
      }
    },
    {
      field: 'stakeholderContactNo', headerName: 'Contact Details(1stParty)', width: 150, hide: (tabValue === "Unloading" && stakeholderDetails?.category === "LLE"),
      renderCell: (cellValues) => {
        return (
          tabValue === "Loading" ?
            <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderContactNo : cellValues?.row?.firstPartyContactNo}</>
            :
            <> {cellValues?.row?.firstPartyContactNo} </>
        );
      }
    },
    {
      field: 'stakeholderLocationName', headerName: 'Location(1stParty)', width: 150, hide: (tabValue === "Unloading" && stakeholderDetails?.category === "LLE"), renderCell: (cellValues) => {
        return (
          tabValue === "Loading" ?
            <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderLocationName : cellValues?.row?.firstPartyLocationName}</>
            :
            <> {cellValues?.row?.firstPartyLocationName} </>
        );
      }
    },
    {
      field: 'secondPartyUrn', headerName: 'URN(2ndParty)', width: 150,
      renderCell: (cellValues) => {
        return (
          tabValue === "Unloading" ?
            <>{cellValues?.row?.secondPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderUrn : cellValues?.row?.secondPartyUrn}</>
            :
            <> {cellValues?.row?.secondPartyUrn} </>
        );
      }
    },
    {
      field: 'secondPartyContactNo', headerName: 'Contact Details(2ndParty)', width: 150,
      renderCell: (cellValues) => {
        return (
          tabValue === "Unloading" ?
            <>{cellValues?.row?.secondPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderContactNo : cellValues?.row?.secondPartyContactNo}</>
            :
            <> {cellValues?.row?.secondPartyContactNo} </>
        );
      }
    },
    {
      field: 'secondPartyLocationName', headerName: 'Location(2ndParty)', width: 150,
      renderCell: (cellValues) => {
        return (
          tabValue === "Unloading" ?
            <>{cellValues?.row?.secondPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderLocationName : cellValues?.row?.secondPartyLocationName}</>
            :
            <> {cellValues?.row?.secondPartyLocationName} </>
        );
      }
    },
    {
      field: 'scheduledDeliveryDate', headerName: 'Delivery Date', width: 150,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY")
    },
    { field: 'poStpoNumber', headerName: 'PO Number', width: 150 },
    { field: 'inventoryType', headerName: 'Type of Inventory', width: 150 },
    {
      field: 'isScheduledApproved', headerName: 'Approval Status', width: 150,
      valueFormatter: (params) => {
        if (params.value === true) {
          return 'Approved';
        }
        else if (params.value === false) {
          return 'Rejected';
        }
        else {
          return '';
        }
      },
      getCellValue: (params) => {
        if (params?.row?.scheduleStakeholderType === stakeholderDetails?.category) {
          return <>{params?.row?.isScheduledApproved}</>;
        } else if (params?.row?.firstPartyType === stakeholderDetails?.category) {
          return <>{params?.row?.isFirstPartyApproved}</>;
        } else {
          return <>{params?.row?.isSecondPartyApproved}</>;
        }
      },
    },
    // { field: '', headerName: 'Action', width: 100 },
    {
      field: 'Navigate', headerName: 'Navigate', width: 200, hide: stakeholderDetails?.category != "HIT",
      renderCell: (cellValues) => {
        return (
          <Button
            variant="contained"
            color="primary"
            onClick={() => harvestingDetails(cellValues)}
          >
            Harvesting Details
          </Button>
        );
      }
    },
    {
      field: 'Print', headerName: "Print", width: 200, hide: stakeholderDetails?.category != "HIT",
      renderCell: () => {
        return (
          <Button
            variant="contained"
            color="primary"
          >
            Print
          </Button>
        );
      }
    }
  ];

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    if (newValue === "Chipping") {
      getLpiWeeklySchedule({ target: { value: lpischeduleno[0] } }, searchFilter?.weeklyScheduleNumber, newValue)
    } else {
      getLpiWeeklySchedule(event, searchFilter?.weeklyScheduleNumber, newValue)
    }

  };
  const harvestingDetails = (cellValues) => {
    navigate('./harvestingDetails', {
      state: cellValues
    });
  }
  // const handleChange = (e) => {
  //   if (e.target.name === "pickUpFromDate" || e.target.name === "pickUpToDate") {
  //     setSearchFilter({ ...searchFilter, [e.target.name]: e.target.value })
  //   }
  // }

  function searchByDate(e) {
    e.preventDefault();
    getLpiWeeklySchedule(e, searchFilter?.pickUpFromDate, searchFilter?.pickUpToDate);
  }

  const onApproveButtonClick = (approval) => {
    loaderService.showLoader();
    let data = selectedRows.map(selectedRow => {
      return {
        stakeholderType: selectedRow.scheduleStakeholderType,
        "weeklyScheduleNumber": selectedRow.weeklyScheduleNumber,
        "scheduleLineNumber": selectedRow.scheduleLineNumber
      }
    })
    apiClient
      .post(
        APPROVE_STAKEHOLDER_SCHEDULE,
        {
          "lstStakeholderWeeklyScheduleApproveDTO": [
            ...data
          ],
          "isApproved": approval
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token')
          }
        },
        null
      )
      .then((response) => {
        setApproveButtonData(response.data);
        getLpiWeeklySchedule(null, searchFilter?.weeklyScheduleNumber);
        // console.log(approveButtonData);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        // console.log(approveButtonData);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  };

  useEffect(() => {
    if (approveButtonData) {
      if (approveButtonData.isSuccess === true) {
        toast.success(approveButtonData?.message)
        // handleLogModalOpen2();
      } else {
        toast.error(approveButtonData?.message ? approveButtonData?.message : "Error");
        // handleLogModalOpen();
      }
    }
  }, [approveButtonData]);

  // const onApprove = (e) => {
  //   e.preventDefault();
  //   onApproveButtonClick(true);
  // }

  // const onReject = (e) => {
  //   e.preventDefault();
  //   onApproveButtonClick(false);
  // }

  const onConfirmApprove = () => {
    handleConfirmClose();
    onApproveButtonClick(true);
  }

  const onApprove = (e) => {
    handleConfirmOpen();
  }

  const onConfirmReject = (e) => {
    handleConfirmClose2();
    onApproveButtonClick(false);
  }

  const onReject = (e) => {
    handleConfirmOpen2();
  }


  return (
    <>
      <Container maxWidth="xxl">

        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT09</p>}
        <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
          <Typography variant="h4" gutterBottom>
            Weekly Plan
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1} hidden={stakeholderDetails}>
            <>
              <Stack direction="row" spacing={1}>
                <Button variant="contained" hidden={lpiweeklyscheduledata?.length === 0} disabled={selectedRows?.length < 1} onClick={(e) => onApprove(e)} startIcon={<ApproveIcon />}>
                  Approve
                </Button>
                <Button variant="contained" hidden={lpiweeklyscheduledata?.length === 0} disabled={selectedRows?.length < 1} onClick={(e) => onReject(e)} startIcon={<CancelIcon />}>
                  Reject
                </Button>
              </Stack>
            </>
          </Stack>
        </Stack>
        <Card>
          <TabContext value={tabValue} style={{ marginLeft: "1.5vh" }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                <Tab label="Chipping" value="Chipping" />
                <Tab label="Loading" value="Loading" />
                <Tab label="Unloading" value="Unloading" />
              </TabList>
            </Box>
            <TabPanel value="Chipping" >
              <Grid container spacing={2} mb={1}>
                <Grid item xs={6} lg={4} mb={1}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Schedule Number</InputLabel>
                    <Select
                      label="Schedule Number"
                      name='weeklyScheduleNumber'
                      // disabled={isDisabled()}
                      value={searchFilter.weeklyScheduleNumber}
                      onChange={(e) => getLpiWeeklySchedule(e)}
                    >
                      <MenuItem selected={searchFilter.weeklyScheduleNumber ? true : false}>Select</MenuItem>
                      {lpischeduleno.map((lpischNo, index) => {
                        return <MenuItem selected={index === 0 ? true : false} value={lpischNo}>{lpischNo}</MenuItem>
                      }
                      )
                      }
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              {/* <p style={{ margin: "0vw" }} className="fromToLable">Schedule Number:</p>
                      <div className='ght-row'>
                        <select className='scheduleNo-dropdown' style={{ marginLeft: "0vw" }} onChange={(e) => getLpiWeeklySchedule(e, '')}>

                          <option selected={searchFilter?.weeklyScheduleNumber ? true : false}>select</option>
                          {lpischeduleno.map(
                            (lpischNo, index) => {
                              return <option selected={(index === 0) ? true : false} value={lpischNo}>{lpischNo}</option>
                            }
                          )
                          }
                        </select>
                        <button className='search-nutton-ght' style={{ border: "0.2vh solid #000000", height: "5.6vh" }} onClick={(e) => { e.preventDefault(); setLpiVisible(!lpiVisible) }}>
                          Search
                        </button>
                        {lpiVisible && <>
                          <div style={{ width: "28vw", marginRight: "0vw" }}>
                            <input className='search-field' type="text" placeholder='Search' name="weeklyScheduleNumber" value={searchFilter?.weeklyScheduleNumber} onChange={(e) => handleFilter(e)} onKeyDown={(evt) => (evt.key === '.' || evt.key === '+') && evt.preventDefault()} ></input>
                            <button style={{ border: "0.2vh solid #000000", height: "6vh", borderRadius: "1vh" }} onClick={(e) => searchScheduleDetails(e)}>
                              <SearchIcon />
                            </button>
                          </div>
                        </>
                        }
                      </div> */}
              <Card>
                <Box style={{ height: 400, width: '100%' }}>
                  {
                    lpiweeklyscheduledata &&
                    <DataGrid rows={lpiweeklyscheduledata}
                      columns={columns}
                      pageSize={5}
                      components={{ Toolbar: QuickSearchToolbar }}
                      checkboxSelection = {!stakeholderDetails}
                      onSelectionModelChange={(ids) => {
                        console.log("in row selected");
                        const selectedIDs = new Set(ids);
                        const selectedRowData = lpiweeklyscheduledata?.filter((row) =>
                          selectedIDs.has(row.id.toString())
                        )
                        setSelectedRows(selectedRowData);
                      }}

                      isRowSelectable={(params) => !((params.row.isScheduledApproved === true || params.row.isScheduledApproved === false) || (params.row.isFirstPartyApproved === true || params.row.isFirstPartyApproved === false) || (params.row.isSecondPartyApproved === true || params.row.isSecondPartyApproved === false))}
                    />
                  }

                </Box>
              </Card>
            </TabPanel>
            <TabPanel value="Loading">
              <Grid container spacing={2} mb={1}>
                {stakeholderDetails?.category === "Grower" || stakeholderDetails?.category === "LLE" ?
                  <>
                    <Grid item xs={12} lg={4}>
                      <FormControl fullWidth >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DesktopDatePicker
                            label="Scheduled From"
                            inputFormat="DD/MM/YYYY"
                            name="pickUpFromDate"
                            value={fromDate}
                            onChange={date => setFromDate(date)}
                            // onChange={(e) => { handleChangeDate(e) }}
                            renderInput={(params) => <TextField size="small" {...params} />}
                          />
                        </LocalizationProvider>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <FormControl fullWidth >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DesktopDatePicker
                            value={toDate}
                            // onChange={handleDateChange}
                            onChange={date => setToDate(date)}
                            // minDate={addDays(new Date(), 7)} // Set minimum date to one week later
                            inputFormat="DD/MM/YYYY"
                            label="Scheduled To"
                            renderInput={(params) => <TextField size="small" {...params} />}
                          />
                        </LocalizationProvider>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <Button variant="contained" onClick={(e) => searchByDate(e)} >Search
                      </Button>
                    </Grid>
                  </>
                  :
                  <>
                    <p style={{ marginTop: "1vh" }}>Schedule Number:</p>
                    <select className='ght-dropdown' onChange={(e) => getLpiWeeklySchedule(e)}>
                      <option selected={searchFilter.weeklyScheduleNumber ? true : false}>select</option>
                      {lpischeduleno.map(
                        (schNo, index) => {
                          return <option selected={index === 0 ? true : false} value={schNo}>{schNo}</option>
                        }
                      )
                      }
                    </select>
                    <button className='search-nutton-ght' style={{ border: "0.2vh solid #000000", height: "5.6vh" }} onClick={(e) => { e.preventDefault(); setSearchvisible(!searchVisible) }}>
                      Search
                    </button>
                    {searchVisible && <>
                      <div>
                        <input className='search-field' type="text" placeholder='Search' name="weeklyScheduleNumber" value={searchFilter.weeklyScheduleNumber} onChange={(e) => handleFilter(e)} ></input>
                        <button style={{ border: "0.2vh solid #000000", height: "6vh", borderRadius: "1vh" }} onClick={(e) => searchScheduleDetails(e)}>
                          <SearchIcon />
                        </button>
                      </div>
                    </>
                    }</>}
              </Grid>
              <Card>
                <Box style={{ height: 400, width: '100%', }}>
                  {
                    lpiweeklyscheduledata &&
                    <DataGrid rows={lpiweeklyscheduledata}
                      columns={columns2}
                      pageSize={5}
                      components={{ Toolbar: QuickSearchToolbar }}
                      checkboxSelection = {!stakeholderDetails}
                      onSelectionModelChange={(ids) => {
                        // console.log("in row selected");
                        const selectedIDs = new Set(ids);
                        const selectedRowData = lpiweeklyscheduledata?.filter((row) =>
                          selectedIDs.has(row.id.toString())
                        )
                        setSelectedRows(selectedRowData);
                      }}
                      isRowSelectable={(params) => !((params.row.isScheduledApproved === true) || (params.row.isFirstPartyApproved === true) || (params.row.isSecondPartyApproved === true))}
                    />
                  }

                </Box>
              </Card>
            </TabPanel>
            <TabPanel value="Unloading">
              <Grid container spacing={2} mb={1}>

                {stakeholderDetails?.category === "Grower" || stakeholderDetails?.category === "LLE" ?
                  <>
                    <Grid item xs={12} lg={4}>
                      <FormControl fullWidth >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DesktopDatePicker
                            label="Scheduled From"
                            inputFormat="DD/MM/YYYY"
                            value={unloadingFromDate}
                            onChange={date => setUnloadingFromDate(date)}
                            // onChange={(e) => { handleChangeDate(e) }}
                            renderInput={(params) => <TextField size="small" {...params} />}
                          />
                        </LocalizationProvider>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <FormControl fullWidth >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DesktopDatePicker
                            value={unloadingToDate}
                            // onChange={handleDateChange}
                            onChange={date => setUnloadingToDate(date)}
                            // minDate={addDays(new Date(), 7)} // Set minimum date to one week later
                            inputFormat="DD/MM/YYYY"
                            label="Scheduled To"
                            renderInput={(params) => <TextField size="small" {...params} />}
                          />
                        </LocalizationProvider>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <Button variant="contained" onClick={(e) => searchByDate(e)} >Search
                      </Button>
                    </Grid>

                  </>
                  :
                  <><p style={{ marginTop: "1vh" }}>Schedule Number:</p>
                    <select className='ght-dropdown' onChange={(e) => getLpiWeeklySchedule(e)}>
                      <option selected={searchFilter.weeklyScheduleNumber ? true : false}>select</option>
                      {lpischeduleno.map(
                        (schNo, index) => {
                          return <option selected={index === 0 ? true : false} value={schNo}>{schNo}</option>
                        }
                      )
                      }
                    </select>
                    <button className='search-nutton-ght' style={{ border: "0.2vh solid #000000", height: "5.6vh" }} onClick={(e) => { e.preventDefault(); setSearchvisible(!searchVisible) }}>
                      Search
                    </button>
                    {searchVisible && <>
                      <div>
                        <input className='search-field' type="text" placeholder='Search' name="weeklyScheduleNumber" value={searchFilter.weeklyScheduleNumber} onChange={(e) => handleFilter(e)} ></input>
                        <button style={{ border: "0.2vh solid #000000", height: "6vh", borderRadius: "1vh" }} onClick={(e) => searchScheduleDetails(e)}>
                          <SearchIcon />
                        </button>
                      </div>
                    </>
                    }</>}
              </Grid>
              <Card>
                <Box style={{ height: 400, width: '100%' }}>
                  {
                    lpiweeklyscheduledata &&
                    <DataGrid rows={lpiweeklyscheduledata}
                      columns={columns3}
                      pageSize={5}
                      components={{ Toolbar: QuickSearchToolbar }}
                    />
                  }

                </Box>

              </Card>
            </TabPanel>
          </TabContext>
        </Card>

      </Container>
      <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmApprove} onClose={handleConfirmClose} action="Approve" />
      <ConfirmationPopover onOpen={confirmOpen2} onConfirm={onConfirmReject} onClose={handleConfirmClose2} action="Reject" /> 

      <Dialog maxWidth='xs' fullWidth open={logModalOpen2}>
        <DialogContent>
          <ConfirmPopover title={approveButtonData?.message ? approveButtonData?.message : "Error"} hideLink={true} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogModalClose2}>OK</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
export default LpiSchedule;